import React, { useState, useEffect } from 'react';
import Pagination from "react-js-pagination";
import CustomModalLink from '../../components/CustomModalLink'
import Veiw from './Veiw';
import {
  Box,
  HStack,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useDisclosure,

  Input,
  Flex,
  Icon,


} from '@chakra-ui/react';
import Select from 'react-select'
import { InputGroup, InputRightElement, IconButton } from '@chakra-ui/react';
import { LuSearch, LuX } from 'react-icons/lu';
import { fetchWrapper, getUserTimeZone } from '../../helpers';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment';
import PageLoader from '../../components/Loader/PageLoader';

function List() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [list, setList] = useState([])
  const [customer, setCustomer] = useState([])
  const [searchCustomer, setSearchCustomer] = useState("");
  const [date, setDate] = useState('')
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(() => {
    const customerId = searchParams.get('customer_id');
    const customerName = searchParams.get('customer_name');
    return customerId && customerName ? { id: customerId, name: customerName } : '';
  });
  const [modelHeader, setModelHeader] = useState('')
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [modalEditView, setModalEditView] = useState(false)
  const { onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
  const [activePage, setActivePage] = useState(parseInt(searchParams.get('page') || '1'));
  const [listCount, setListCount] = useState(0);

  useEffect(() => {
    LoadList(
      selectedCustomer.id,
      date,
      searchValue,
    )
    loadCustomerList();
  }, [selectedCustomer, date, activePage])

  // Function to update URL parameters
  const updateUrlParams = () => {
    const params = new URLSearchParams(searchParams);

    if (selectedCustomer && selectedCustomer.id) {
      params.set('customer_id', selectedCustomer.id);
      params.set('customer_name', selectedCustomer.name);
    } else {
      params.delete('customer_id');
      params.delete('customer_name');
    }

    params.set('page', activePage.toString());
    setSearchParams(params);
  };

  useEffect(() => {
    updateUrlParams();
  }, [selectedCustomer, activePage]);

  const LoadList = async (customer_id = "0", date = "", searchValue = "") => {
    setLoading(true)

    const url = `${process.env.REACT_APP_API_URL}/webhook/list?customer_id=${customer_id}${date ? `&date=${moment(date).format('DD/MM/YY')}` : ""}&message_id=${searchValue}&page=${activePage}`;
    const data = await fetchWrapper.get(url)
    setList(data.data)
    setListCount(data.count)
    setLoading(false)
  }


  const loadCustomerList = async () => {
    const url = `${process.env.REACT_APP_API_URL}/customer/list`;
    const data = await fetchWrapper.get(url)
    setCustomer(data.data);
  }



  const filteredCustomer = customer?.filter((rs) =>
    rs.business_name.toLowerCase().includes(searchCustomer.toLowerCase())
  );

  const handleSelect = (type, rs) => {
    if (type === 'customer') {
      setSelectedCustomer(rs || '');
    }
  };

  const meSearch = (type, e) => {

    if (type === "customer") {
      setSearchCustomer(e.target.value)
    }

  }

  const handleSearchClick = () => {
    LoadList(
      selectedCustomer.id,
      date,
      searchValue,
    )

    // setSearchValue('')
  };

  const clearSearch = () => {
    setSearchValue('')
    LoadList(
      selectedCustomer.id,
      date,
      "",
    )
  };

  const meCloseEdit = () => {

    setIsOpenEdit(false);

  }

  const meVeiw = (type, rs) => {
    if (type === "veiw_data") {
      setIsOpenEdit(true);
      setModelHeader('Data Posted')
      setModalEditView(<Veiw meCloseEdit={meCloseEdit} rs={rs} type={type} />);
    }

    if (type === "veiw_response") {
      setIsOpenEdit(true);
      setModelHeader('Resposne')
      setModalEditView(<Veiw meCloseEdit={meCloseEdit} rs={rs} type={type} />);
    }

  }


  const onChangePaginate = (pageNumber) => {
    setActivePage(pageNumber);
    // to set offset

  };

  return (
    <>
      <CustomModalLink
        showModalButtonText={modelHeader}
        modalHeader={modelHeader}
        isOpenEdit={isOpenEdit}
        onCloseEdit={meCloseEdit}
        onOpenEdit={onOpenEdit}

        modalBody={modalEditView}
      />
      <PageLoader isLoading={loading} />

      <div className="body_section">


        <HStack justifyContent="space-between" mb="25px" w="100%">
          <Box w="30%">
            <Text fontSize="32px" fontWeight="300" color="#000000" my="0px" fontFamily="'Open Sans', sans-serif">Webhook Logs</Text>
          </Box>
          <Box w="65%">
            <HStack w="100%" justifyContent="flex-end">
              <Box w="395px">
                <InputGroup>
                  <Input type="text" placeholder="Search using Message ID or Phone No"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                  />

                  <InputRightElement width="unset">
                    <IconButton
                      aria-label="Search"
                      icon={<Icon as={LuSearch} color="gray.300" />}
                      onClick={handleSearchClick}
                      variant="link"
                      pointerEvents="auto"
                    />
                    <IconButton
                      aria-label="Clear"
                      icon={<Icon as={LuX} color="gray.300" />}
                      onClick={clearSearch}
                      variant="link"
                      pointerEvents="auto"
                    />
                  </InputRightElement>

                </InputGroup>
              </Box>

              <Box w={200}>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Customer"
                  isClearable={true}
                  isSearchable={true}
                  name="customer"
                  options={customer}
                  getOptionLabel={(e) => e.business_name}
                  getOptionValue={(e) => e.id}
                  onChange={(e) => handleSelect('customer', e || '')}
                  value={selectedCustomer}
                />

              </Box>
              {/* <Box>
                <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
              </Box> */}

            </HStack>
          </Box>
        </HStack>


        <div className="table_section">
          <TableContainer width="100%">
            <Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
              <Thead >
                <Tr>
                  <Th>Message ID</Th>
                  <Th>Date & Time</Th>
                  <Th>Customer</Th>
                  <Th>Channel</Th>

                  <Th>Url</Th>
                  <Th>Data Posted</Th>
                  <Th>Response</Th>




                </Tr>
              </Thead>

              <Tbody fontSize="14px">

                {list?.length > 0 ? list.map((rs, index) => {
                  return (

                    <Tr key={index}>
                      <Td>{rs?.message_id ? rs?.message_id : "-"}
                      </Td>
                      <Td>
                        {moment
                          .unix(JSON.parse(rs.data_posted).date_time) // parse Unix timestamp (in seconds)
                          .tz(getUserTimeZone())                      // apply user timezone
                          .format('DD/MM/YY | hh:mm:ss A')}
                      </Td>

                      <Td>{rs?.business_name}</Td>
                      <Td>{JSON.parse(rs.data_posted)?.channel}</Td>


                      <Td>{rs.url ? rs.url : "-"}</Td>
                      <Td onClick={() => meVeiw('veiw_data', rs)} style={{ color: '#1F5AF4', cursor: 'pointer' }}> View</Td>
                      <Td onClick={() => meVeiw('veiw_response', rs)} style={{ color: '#1F5AF4', cursor: 'pointer' }}>View</Td>

                    </Tr>
                  )

                }) : ""}

              </Tbody>


            </Table>
            <Flex justifyContent="center" alignItems="center" my={4}>

              <Pagination
                activePage={activePage}
                itemsCountPerPage={100}
                totalItemsCount={listCount}
                pageRangeDisplayed={100}
                onChange={onChangePaginate}
                innerClass="pagination"
                itemClass="page-item"
                activeLinkClass="page-link active"
                linkClass="page-link"
                prevPageText="Previous"
                nextPageText="Next"
              />
            </Flex>
          </TableContainer>
        </div>
      </div>
    </>
  )
}

export default List;